import * as React from "react";
import { Modal } from "@lib/components";
import { RotateLoader } from "@lib/components";
import {
	ButtonV2,
	EditingStatusAlertModalBody,
	EditingStatusAlertModalContent,
	EditingStatusAlertModalHeader,
	EditingStatusAlertModalHeaderText,
	EditingStatusIconWrapper,
} from "./layout.c";
import { IconEditingClose } from "./icons";

interface BulkConfirmModalProps {
	active: boolean;
	title: string;
	description?: string;
	confirmText?: string;
	cancelText?: string;
	loading?: boolean;
	confirmDisabled?: boolean;
	onClose: () => void;
	onConfirm: () => void;
	children?: React.ReactNode;
}

export const BulkConfirmModal = (props: BulkConfirmModalProps) => {
	const {
		active,
		title,
		description,
		confirmText = "Apply",
		cancelText = "Cancel",
		loading,
		confirmDisabled,
		onClose,
		onConfirm,
		children,
	} = props;
	if (!active) return null;
	const applyDisabled = !!(loading || confirmDisabled);

	return (
		<Modal width={560} close={onClose} closeButton={false} active={active}>
			<EditingStatusAlertModalContent style={{ width: "100%", boxShadow: "none" }}>
				<EditingStatusAlertModalHeader>
					<EditingStatusAlertModalHeaderText>{title}</EditingStatusAlertModalHeaderText>
					<EditingStatusIconWrapper onClick={onClose}>
						<IconEditingClose />
					</EditingStatusIconWrapper>
				</EditingStatusAlertModalHeader>
				{description && (
					<p style={{ margin: 0, color: "#4B4F5E", fontSize: 14, lineHeight: "20px" }}>
						{description}
					</p>
				)}
				{children}
				<EditingStatusAlertModalBody style={{ width: "100%" }}>
					<ButtonV2
						className="flex-auto"
						disabled={applyDisabled}
						onClick={onConfirm}
						style={applyDisabled ? { opacity: 0.6, cursor: "not-allowed" } : undefined}
					>
						{loading ? <RotateLoader size={2} color="white" /> : confirmText}
					</ButtonV2>
					<ButtonV2 variant="default" onClick={onClose}>
						{cancelText}
					</ButtonV2>
				</EditingStatusAlertModalBody>
			</EditingStatusAlertModalContent>
		</Modal>
	);
};
